import { Box } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildExpensableGroupsDataTableFilter,
} from 'generated/resources/datatable.graphql'
import { LegalEntityForSelectFragment } from 'generated/resources/graphql'

import useFilter from 'modules/core/components/Filter/base/useFilter'
import { LegalEntitySelector } from 'modules/core/components/LegalEntitySelector'
import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'

const LegalEntityFilterComponent = () => {
  const { value, onValueChange } = useFilter<LegalEntityForSelectFragment[]>()

  return (
    <Box width="s400" flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <LegalEntitySelector
        width="s400"
        multiple
        hideBorder
        alwaysOpen
        label={''}
        value={value ?? []}
        onChange={onValueChange}
      />
    </Box>
  )
}

const legalEntityFilter = ({ source }: BaseFilterProps) => {
  return buildExpensableGroupsDataTableFilter(source, {
    type: FilterType.Entity,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'legalName',
        component: () => <LegalEntityFilterComponent />,
      },
    ],
    identifier: 'expensesList.legalEntityFilter',
    path: 'legalEntity',
    title: i18n.t('expenses_v2.list.filters.label_legal_entity'),
  })
}

export default legalEntityFilter
